<template>
   <Forms ref="frmSearch"
           title="PESQUISA DE FUNCIONÁRIO"
           :showHelp="true"
           :showClearButton="true"
           :showSearchButton="true"
           :showNewButton="false"
           :ShowFooterImbo="true"
           :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
           v-on:Clear="onClearSection"
           v-on:Search="Search"
           >
            <div class="form-group row">
            <label class="label-search">Funcionário:</label>
            <autocomplete-z ref="favorecidoTypeahead"
                placeholder="Digite o nome do Funcionário"
                iconClass="fas fa-id-badge"
                :serializer="(favorecido) => favorecido.codigo + ' - ' + favorecido.nome"
                :debounceLength="3"
                :formField="form.funcionarioId"
                :returnCallback="true"
                v-on:search="onSearchFavorecido"
                v-on:changeCode="onChangeCodeFavorecido" />
            </div>
   </Forms>
</template>

<script>
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
// import AcceptanceTermRepository from '@/shared/http/repositories/business/acceptanceterm'
// import SectionRHRepository from '@/shared/http/repositories/business/sectionrh'
// import ExpenseRepository from '@/shared/http/repositories/business/expense'
// import { loading } from '@/shared/utils/UIHelper'
export default {
  name: 'ExpenseSearch',
  components: {AutocompleteZ},
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      dataStatusDespesa: [],
      form: {
        funcionarioId: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      }
    }
  },
  methods: {
    Search () {
      this.$emit('search', {FuncionarioID: this.form.funcionarioId.value})
    },
    onClearSection () {
      this.$refs.favorecidoTypeahead.clear()
    }
  }
}
</script>

<style>
.label-search{
    padding-bottom: 0px;
    margin-bottom: 0px;
    margin-top: 10px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/miscellaneousreimbursement/components/FilterSeveralContributor/FilterSeveralContributor.vue